<template>
  <div>
    <v-btn icon small color="teal" v-if="isEdit || isAdded">
      <v-icon @click="setItem('save')">mdi-content-save-edit</v-icon>
    </v-btn>
    <v-btn icon small color="teal" v-else>
      <v-icon @click="setItem('edit')">mdi-pencil</v-icon>
    </v-btn>
    <v-btn icon small color="error">
      <v-icon @click="setItem('delete')">mdi-delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderItem: null,
    isEdit: false,
  }),
  computed: {
    isAdded() {
      return this.params.data.id == 0;
    },
  },
  methods: {
    setItem(type) {
      let data = this.params.data;
      data.type = type;
      if (type == "edit") this.isEdit = true;
      else this.isEdit = false;
      this.params.clicked(data);
    },
  },
});
</script>
